module.exports = __webpack_public_path__ + "img/xy.png";